import { MsInformationCircle as o, MsCheckMedal as t } from "@sunrise/icons";
import { Components as e } from "@sunrise/types";
import { defineComponent as n } from "vue";
const r = n({
  name: "CsTag",
  components: {
    MsCheckMedal: t,
    MsInformationCircle: o
  },
  props: {
    type: {
      type: String,
      default: e.CsTag.Type.Default
    },
    colorClass: String,
    isIconRight: {
      type: Boolean,
      default: !1
    }
  },
  setup() {
    return { types: e.CsTag.Type };
  }
});
export {
  r as default
};
